import { Component, Input } from '@builder.io/sdk';

import moleculeAccordionFields from 'molecules/Accordion/config';

const articleAccordionFields = [
  {
    name: 'htmlId',
    type: 'string',
    defaultValue: 'article-accordion',
    helperText: 'Unique ID for anchor linking (e.g. "faq"). Must be unique on the page.',
  },
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Frequently asked questions',
    helperText: 'Section heading. Always left aligned. Leave empty to render the accordion on its own.',
  },
  {
    name: 'headingTag',
    type: 'string',
    defaultValue: 'h2',
    enum: [
      { label: 'H2', value: 'h2' },
      { label: 'H3', value: 'h3' },
      { label: 'H4', value: 'h4' },
    ],
    helperText: 'Semantic heading level. H2 also adds the heading to the article table of contents.',
  },
  {
    name: 'headingSize',
    type: 'string',
    defaultValue: 'article',
    enum: [
      { label: 'Article (matches the other headings in the article)', value: 'article' },
      { label: 'Large (matches the page-section accordion)', value: 'large' },
    ],
    helperText: 'Article keeps the heading in step with the surrounding copy. Large matches the standard accordion.',
  },
  {
    name: 'subheading',
    type: 'richText',
    helperText:
      'Optional copy below the heading. When this is empty the heading sits directly on the first accordion item, with no gap.',
  },
  {
    name: 'spaceBefore',
    type: 'string',
    defaultValue: 'sm',
    enum: ['none', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'],
    helperText:
      'Space above the block, on top of the 24px the article already puts between blocks. Default sm matches how a normal H2 sits in the article.',
  },
  {
    name: 'spaceAfter',
    type: 'string',
    defaultValue: 'lg',
    enum: ['none', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'],
    helperText:
      'Space below the block, on top of the 24px the article already puts between blocks. Raise this to separate the accordion from whatever follows it.',
  },
  ...moleculeAccordionFields,
  {
    name: 'isBulletStandard',
    type: 'boolean',
    defaultValue: true,
    helperText: 'If enabled, to match Figma’s standard bullets. Disable to uses Prismatic’s custom bullets.',
  },
  {
    name: 'className',
    type: 'string',
    defaultValue: '',
    helperText: 'Optional class name applied to the whole block, for custom styling.',
  },
] as const satisfies DeepReadonly<Input[]>;

const articleAccordionConfig = {
  name: 'articleAccordion',
  inputs: articleAccordionFields,
} satisfies Component;

export type ArticleAccordionConfigProps = GenerateBuilder<typeof articleAccordionFields>;

export default articleAccordionConfig;
